import { useLocation, useSearchParams } from 'react-router-dom';
import { useGetPlanetaryTransitFromMoonQuery } from '@/store/api/planteryTransitApi';
import { skipToken } from '@reduxjs/toolkit/query';
import Loader from '@/components/Loader';
import { formatDateTime } from '@/utils/formatDateTime';

import { groupBySign } from '@/utils/groupBySign';
import { formatDegree } from '@/utils/degreeUtils';

export default function PlanetaryTransit() {
  const [params] = useSearchParams();

  const { state } = useLocation();
  const user = state?.user;

  const userId = params.get('userId');
  const rashi = user?.BirthDetail?.astroData?.sign;

  const { data, isLoading, isError } = useGetPlanetaryTransitFromMoonQuery(
    userId ? { userId, rashi } : skipToken
  );

  if (isError) {
    return <p className="p-6 text-center text-red-500">Failed to load Planetary Transit data</p>;
  }

  const groupedData = groupBySign(data?.transit ?? []);

  return (
    <div className="">
      <h3 className="font-32 font-semibold font-spectral mb-6 bg-clip-text text-transparent bg-gradient-to-r from-[#082261] to-[#34065c] text-center heading-uppercase">
        PLANETARY TRANSIT POSITION FROM MOON / RASHI({data?.transit?.[0]?.sign})
      </h3>
      <div className="text-center font-lato font-20 text-[#082261] mb-4">
        As on : {formatDateTime(data?.date)}
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full border-collapse border border-[#2DAAFD] font-18 whitespace-nowrap">
          <thead className="bg-[#001B6B] text-white font-spectral uppercase">
            <tr>
              <th className="border px-3 py-2">Sign</th>
              <th className="border px-3 py-2">Natal Planet(s)</th>
              <th className="border px-3 py-2">House No</th>
              <th className="border px-3 py-2">Transiting Planet(s)</th>
              <th className="border px-3 py-2">Degree</th>
              <th className="border px-3 py-2">Nakshatra</th>
              <th className="border px-3 py-2">Pada</th>
              <th className="border px-3 py-2">Awastha</th>
              <th className="border px-3 py-2">Retro</th>
            </tr>
          </thead>

          <tbody>
            {groupedData.map((group, gi) =>
              group.rows.map((row: any, ri: number) => (
                <tr
                  key={`${gi}-${ri}`}
                  className={
                    gi % 2 === 0 ? 'bg-white' : 'bg-[linear-gradient(to_right,#B7E2FF,#2DAAFD)]'
                  }
                >
                  {ri === 0 && (
                    <td
                      rowSpan={group.rows.length}
                      className="border px-3 py-2  align-middle border-black"
                    >
                      {group.sign}
                    </td>
                  )}

                  {ri === 0 && (
                    <td
                      rowSpan={group.rows.length}
                      className="border px-3 py-2 text-center align-middle border-black"
                    >
                      {row.natalPlanets?.length
                        ? row.natalPlanets.map((p: string, i: number) => <div key={i}>{p}</div>)
                        : '-'}
                    </td>
                  )}

                  {ri === 0 && (
                    <td
                      rowSpan={group.rows.length}
                      className="border px-3 py-2 text-center align-middle border-black"
                    >
                      {row.house ?? '-'}
                    </td>
                  )}

                  <td className="border px-3 py-2 text-center border-black">{row.planet ?? '-'}</td>

                  <td className="border px-3 py-2 text-center border-black">
                    {formatDegree(group.sign, row.degree)}
                  </td>

                  <td className="border px-3 py-2 text-center border-black">
                    {row.nakshatra ?? '-'}
                  </td>

                  <td className="border px-3 py-2 text-center border-black">{row.pada ?? '-'}</td>

                  <td className="border px-3 py-2 text-center border-black">
                    {row.awastha ?? '-'}
                  </td>

                  <td className="border px-3 py-2 text-center capitalize border-black">
                    {String(row.retro ?? '-')}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
